import Activity from '@/models/Activity';
import { HourOfWork, HoursOfWorkListDto } from '@/models/HoursOfWork';

export const useActivityHoursOfWork = () => {
  const getActivityHoursOfWork = (
    activity: Activity,
    availableHours: Nullable<HoursOfWorkListDto[]>,
  ): Nullable<HoursOfWorkListDto[]> => {
    if (!activity.isBusy) {
      return availableHours?.map(item => {
        return {
          ...item,
          hours: makeAllHoursAvasilable(item.hours),
        }
      }) || [];
    } else {
        return availableHours;
    }
  }

  const makeAllHoursAvasilable = (hours?: HourOfWork[]) => {
    return hours?.map(hour => {
      return {...hour, isAvailable: true,} as HourOfWork
    }) || [];
  }

  return {
    getActivityHoursOfWork,
  }
}
